import FrontpageStyles from './Frontpage.module.css';
import BordersStyles from './Borders.module.css';
import OpenBookCover from "./photos/BookDecorWebP/BookofAbdul_BookCover.webp"; // Book cover image will appear on main pages.
import FrontBookCover from "./photos/BookDecorWebP/BookofAbdul_FrontBookCover.webp";
import BackBookCover from "./photos/BookDecorWebP/BookofAbdul_BackBookCover.webp";
import IndividualPage from "./photos/BookDecorWebP/BookofAbdul_Pages(Individual).webp";
import BookofAbdulFrontLogo from "./photos/BookDecorWebP/BookofAbdul_Logo(FrontCoverV2).webp";

function FrontPage() {
    const open = 
        {
            title: "OpenBookCover",
            photo: OpenBookCover,
            id: 1
        };

    const page = 
        {
            title: "IndividualPage",
            photo: IndividualPage,
            id: 2
        };

    const logo = 
        {
            title: "BookofAbdulFrontLogo",
            photo: BookofAbdulFrontLogo,
            id: 3
        };

    const front = 
        {
            title: "FrontBookCover",
            photo: FrontBookCover,
            id: 4
        };

    const back = 
        {
            title: "BackBookCover",
            photo: BackBookCover,
            id: 5
        };

    const pagenums = 13;

    return (
        <section className="Book-of-Abdul-Book-Placement">
            <div id="BoA-book-cover-open">
                <img id="BoA-open-img" src={open.photo} alt={open.title}/>
            </div>
            <div id="BoA-book-cover-front" style={{opacity: "0.0"}}>
                <img id="BoA-front-img" src={front.photo} alt={front.title}/>  
            </div>
            <div id="BoA-book-cover-back" style={{opacity: "0.0"}}>
                <img id="BoA-back-img" src={back.photo} alt={back.title}/>  
            </div>
            <div className="BoA-background-pages" id="BoA-background-pages">
                <ul className={FrontpageStyles["BoA-individual-pages"]}>
                    {[...Array(pagenums)].map((e, i) => (
                        <li className={"BoA-frontpage-" + i} key={i}>
                            <img className="BoA-page-img" src={page.photo} alt={page.title} key={e}/>
                        </li>
                    ))}
                </ul>                    
                <div className={BordersStyles["BoA-page-content"]} id="BoA-page-content">
                    <img id={FrontpageStyles["BoA-front-logo"]} src={logo.photo} alt={logo.title}/>
                </div>
            </div>
        </section>
    );
}

export default FrontPage;